import { API } from 'aws-amplify'
import { isEmpty } from 'lodash'
import { ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { catchError, filter, map, mapTo, mergeMap, pluck, switchMap, withLatestFrom } from 'rxjs/operators'
import Actions from '../actions'
import { getScopeLGOrderingEnabledForState } from 'utils/scopeOrderUtils'

const getPracticePlanGroup = state => state.practiceReducer?.billing?.grinPlan?.planGroup

const getSelectedPlanGroup = state => state.billingReducer.upgradePlan.selectedPlanGroup

const getScopeProductRequestConfig = (state, actionType) => ({
  requestedPlanGroup:
    actionType === Actions.SET_ORDER_GRIN_KITS_MODAL_VISIBILITY ||
    actionType === Actions.SET_SELECT_PLAN_MODAL_VISIBILITY
      ? getPracticePlanGroup(state)
      : getSelectedPlanGroup(state) || getPracticePlanGroup(state),
  includeScopeLG: getScopeLGOrderingEnabledForState(state)
})

export const watchSelectPlanModalVisibleEpic = (action$, state$) => {
  return action$.pipe(
    ofType(Actions.SET_SELECT_PLAN_MODAL_VISIBILITY),
    pluck('payload'),
    withLatestFrom(state$),
    filter(
      ([isOpen, { billingReducer }]) =>
        isOpen && !billingReducer.grinPlans.isLoading && isEmpty(billingReducer.grinPlans)
    ),
    mapTo(Actions.fetchGrinPlans())
  )
}

export const fetchGrinScopeProductsTrigger = (action$, state$) =>
  action$.pipe(
    ofType(Actions.SET_ORDER_GRIN_KITS_MODAL_VISIBILITY, Actions.SET_SELECT_PLAN_MODAL_VISIBILITY),
    withLatestFrom(state$),
    map(([action, state]) => {
      const { requestedPlanGroup, includeScopeLG } = getScopeProductRequestConfig(state, action.type)

      return {
        isOpened: action.payload,
        requestedPlanGroup,
        includeScopeLG,
        wasScopeLoaded: !isEmpty(state.productReducer.scope.data),
        loadedPlanGroup: state.productReducer.scopePlanGroup,
        loadedIncludeScopeLG: state.productReducer.includesScopeLG
      }
    }),
    filter(
      ({ isOpened, requestedPlanGroup, wasScopeLoaded, loadedPlanGroup, includeScopeLG, loadedIncludeScopeLG }) =>
        !!isOpened &&
        !!requestedPlanGroup &&
        (!wasScopeLoaded || loadedPlanGroup !== requestedPlanGroup || loadedIncludeScopeLG !== includeScopeLG)
    ),
    map(({ includeScopeLG, requestedPlanGroup }) =>
      Actions.fetchGrinScopeProducts({ includeScopeLG, grinPlanGroup: requestedPlanGroup })
    )
  )

export const fetchGrinScopeProductsEpic = (action$, state$) =>
  action$.pipe(
    ofType(Actions.FETCH_GRIN_SCOPE_PRODUCTS),
    withLatestFrom(state$),
    map(([action, state]) => ({
      includeScopeLG: action.payload?.includeScopeLG ?? getScopeLGOrderingEnabledForState(state),
      requestedPlanGroup: action.payload?.grinPlanGroup || getSelectedPlanGroup(state) || getPracticePlanGroup(state)
    })),
    filter(({ requestedPlanGroup }) => !!requestedPlanGroup),
    switchMap(({ includeScopeLG, requestedPlanGroup }) => {
      // LG and LG Mini share the scopeLGOrdering rollout flag, so they are always requested together.
      const includeScopeLGQuery = includeScopeLG ? '&includeScopeLG=true&includeScopeLGMini=true' : ''

      return from(
        API.get(
          'grinApi',
          `/billing/v1/products/scope?includeScopeMini=true${includeScopeLGQuery}&grinPlanGroup=${requestedPlanGroup}`
        )
      ).pipe(
        mergeMap(scopeProduct =>
          of(
            Actions.fetchGrinScopeProductsReceived({
              ...scopeProduct,
              requestedPlanGroup,
              includeScopeLG
            })
          )
        ),
        catchError(response => of(Actions.fetchGrinScopeProductsFailed(response)))
      )
    })
  )
